import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfigService } from 'src/app/core/services/api-config/api-config.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  constructor(
    private http: HttpClient,
    private ApiConfigService: ApiConfigService
  ) {}

  private get baseUrl(): string {
    return `${this.ApiConfigService.apiUrl}/terms`;
  }

  download() {
    return this.http.get(`${this.baseUrl}`, {
      responseType: 'arraybuffer',
    });
  }
}
